import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rds:output-field',
  templateUrl: './output-field.component.html',
  styleUrls: ['./output-field.component.scss']
})
export class OutputFieldComponent implements OnInit {

  	@Input() label: string;
	@Input() value: string;
	@Input() type: string = "text";
	@Input() linkValue: string = "";
	@Input() isCap: boolean = false;
	@Input() toolTipText: string = "View object detail";
	@Input() borders: string = "";

	constructor() { }

	ngOnInit() {
	}
}
